module.exports = __webpack_public_path__ + "static/media/5DPO2.721764f2.jpg";